import React, { useState } from 'react';
import LoadingScreen from './LoadingScreen'; // Import your loading screen component
import * as THREE from 'three';
import { Canvas } from '@react-three/fiber';
import { Environment, MeshReflectorMaterial } from '@react-three/drei';
import Frames from './Frames';

const GOLDENRATIO = 1.61803398875;

const App = ({ images }) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleVideoEnd = () => {
    setIsLoading(false); // Set loading to false when video ends
  };

  return (
    <>
      {isLoading ? (
        <LoadingScreen onVideoEnd={handleVideoEnd} /> // Display the loading screen
      ) : (
        <Canvas dpr={[1, 1.5]} camera={{ fov: 70, position: [0, 2, 15] }}>
          <color attach="background" args={['#191920']} />
          <fog attach="fog" args={['#191920', 0, 15]} />
          <group position={[0, -0.5, 0]}>
            <Frames images={images} />
            <mesh rotation={[-Math.PI / 2, 0, 0]}>
              <planeGeometry args={[50, 50]} />
              <MeshReflectorMaterial
                blur={[300, 100]}
                resolution={2048}
                mixBlur={1}
                mixStrength={80}
                roughness={1}
                depthScale={1.2}
                minDepthThreshold={0.4}
                maxDepthThreshold={1.4}
                color="#050505"
                metalness={0.5}
              />
            </mesh>
          </group>
          <Environment preset="city" />
        </Canvas>
      )}
    </>
  );
};

export default App;
